/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteMachineModal_machine$ref: FragmentReference;
declare export opaque type DeleteMachineModal_machine$fragmentType: DeleteMachineModal_machine$ref;
export type DeleteMachineModal_machine = {|
  +id: string,
  +name: string,
  +$refType: DeleteMachineModal_machine$ref,
|};
export type DeleteMachineModal_machine$data = DeleteMachineModal_machine;
export type DeleteMachineModal_machine$key = {
  +$data?: DeleteMachineModal_machine$data,
  +$fragmentRefs: DeleteMachineModal_machine$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteMachineModal_machine",
  "type": "Machine",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'dcb1c589fe6ee79f1afe654a2202256a';
module.exports = node;
